import { render, staticRenderFns } from "./creat-stick.vue?vue&type=template&id=0adf492f&scoped=true"
import script from "./creat-stick.vue?vue&type=script&lang=js"
export * from "./creat-stick.vue?vue&type=script&lang=js"
import style0 from "./creat-stick.vue?vue&type=style&index=0&id=0adf492f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf492f",
  null
  
)

export default component.exports